import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateClassType } from "../api/queries";
import { ClassTypeForm } from "../ui/class-types/ClassTypeForm";

export function ClassTypeCreatePage() {
  const nav = useNavigate({ from: "/app/master/class-types/create" });
  const createClassType = useCreateClassType();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ປະເພດຄລາດສ໌", to: "/app/master/class-types" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງປະເພດຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">ສ້າງປະເພດຄລາດສ໌ໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/master/class-types" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <ClassTypeForm
            onSubmit={async (vals) => {
              try {
                await createClassType.mutateAsync(vals);

                nav({ to: "/app/master/class-types" });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createClassType.isPending}
          />
        </div>
      </Main>
    </>
  );
}
